import { Component } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { TranslateService } from '@ngx-translate/core';
import { HeaderComponent } from "../header/header.component";
import { FooterComponent } from "../footer/footer.component";

@Component( {
  selector: 'dynamica-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  standalone: true,
  imports: [
    HeaderComponent,
    FooterComponent,
    RouterModule
  ]
} )
export class MainLayoutComponent {
  currentLang = 'en';
  languages = ['de', 'en'];
  routeKey: string;

  constructor(
    private router: Router,
    private oidcSecurityService: OidcSecurityService,
    private translate: TranslateService,
  ) {
    this.translate.addLangs( this.languages );
    this.translate.setFallbackLang( this.currentLang );
    this.translate.use( this.currentLang );

    this.oidcSecurityService.isAuthenticated$.subscribe( ( { isAuthenticated } ) => {
      if( isAuthenticated ) {
        this.router.events.subscribe( event => {
          if( event instanceof NavigationEnd ) {
            this.routeKey = event.url.split( '/' )[1];
          }
        } );
      }
    } );
  }
}
